<template>
  <div class="frm-toggle">
    <input
      type="checkbox"
      :name="name"
      :id="name"
      :disabled="disabled"
      @change="onCheckChanged"
      :checked="checked"
    >
    <label
      :for="name"
      class="_p0 bg-light-gray"
    >
      <async-loader v-if="loading" />
      <div
        v-else-if="label && label.length"
        container
      >
        <div grid="row wrap">
          <div
            column="12"
            v-html="label"
            class="label"
          ></div>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import SimpleCopy from '@sections/SimpleCopy';
import AsyncLoader from '@molecules/AsyncLoader';

export default {
  props: {
    checked: Boolean,
    label: String,
    loading: Boolean,
    name: String,
    value: [Number, String, Date, Boolean, null],
    disabled: Boolean
  },
  emits: ['change'],
  setup(_, { emit }) {

    const onCheckChanged = (e) => {
      emit('change', { name: e.target.name, checked: e.target.checked });
    }

    return {
      onCheckChanged,
    }
  },
  components: {
    AsyncLoader,
    SimpleCopy,
  }
}
</script>

<style scoped>
input {
  width: initial;
}

.label {
  font-size: 0.8rem;
  line-height: 1.7rem;
}

input[type="checkbox"]{
  position: absolute;
  visibility: hidden;
}
input[type="checkbox"] + label:before{
  border:1px solid #777;
  content: " ";
  display:inline-block;
  height:12px;
  width:12px;
  margin-right: 2px;
  margin-top: 0.5rem;
  vertical-align: middle;
}
input[type="checkbox"]:checked + label:before{
  background-color: black;
}
input[type="checkbox"] + label:before{
  border-radius:50%;
}
</style>